<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light bg-light px-3 px-md-1">
            <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNavDropdown"
                aria-controls="navbarNavDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav">
                    <li
                        v-for="cat in categories"
                        :key="cat.id"
                        class="nav-item"
                    >
                        <a
                            class="nav-link"
                            href="javascript:void(0);"
                            :id="'category-' + cat.id"
                            >{{ cat.name }}</a
                        >
                    </li>
                </ul>
            </div>
        </nav>
        <div class="row mt-2">
            <div v-for="route in routes" :key="route.id" class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <h3 class="card-title">{{ route.name }}</h3>

                        <button
                            type="button"
                            class="btn btn-outline-success col-12"
                            data-bs-toggle="modal"
                            data-bs-target="#showModalRoute"
                            @click="openModal(route)"
                        >
                            Ver ruta
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            id="showModalRoute"
            tabindex="-1"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            aria-labelledby="showModalRouteLabel"
            aria-hidden="true"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Agregar ruta de aprendizaje</h5>
                    </div>
                    <div class="modal-body">
                        <div class="row g-3">
                            <div class="col">
                                <h4>{{showRuta.name}}</h4>
                                <p
                                    v-if="showRuta.description"
                                    class="card-text"
                                    v-html="showRuta.description"
                                ></p>
                                <h5>Cursos:</h5>
                                <div class="container">
                                    <div class="row">
                                        <div
                                            v-for="curso in showRuta.curso"
                                            :key="curso.id"
                                            class="col-12"
                                        >
                                            {{curso.title.rendered}}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            id="closeAdd"
                            type="button"
                            class="btn btn-outline-danger"
                            data-bs-dismiss="modal"
                            @click="showRuta = []"
                        >
                            Cerrar
                        </button>
                        <button
                            id="agregar"
                            type="button"
                            @click="agregarRuta"
                            class="btn btn-outline-success"
                        >
                            Guardar cambios
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    props: ["get","rutas"],
    data() {
        return {
            url: this.get,
            urlRoutes:this.rutas,
            categories: [],
            routes:[],
            image: [],
            showRuta: [],
            routeCourse: []
        };
    },
    mounted() {
        console.log('ok');
        // this.getCategory();
        this.getRoutes();
    },
    methods: {
        getCategory() {
            axios.get(this.url + "/category").then((res) => {
                this.categories = res.data;
            });
        },
        getRoutes(cat = null) {
            let url = this.get;
            if (cat) url = this.get + "/category/" + cat;
            console.log(url);
            axios.get(url).then((res) => {
                this.routes = res.data;

                // console.log(this.routes);
            });
        },
        getCurso(id) {
            axios.get(this.url + "/curso/" + id).then(res=>{
                this.routeCourse = res.data
            });

        },
        async getMedia(id) {
            if (id) {
                let response = await axios
                    .get(this.url + "/media/" + id)
                    .then((res) => {
                        this.image[id] = res.data.url;
                    });
                return response;
            } else {
                return false;
            }
        },
        openModal(ruta){
            this.showRuta = ruta;
            // this.getCurso(ruta.id);
        },
        agregarRuta() {
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios.post(this.urlRoutes+'?suggest=true',this.showRuta).then(
                res => {
                    window.location.reload();

                }
            );
        },
    },
};
</script>
